module.exports = __webpack_public_path__ + "fonts/Inter-800-latin77.30a274c.woff2";